import { useLanguage } from '@nzyme/vue-i18n/useLanguage.js';
import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';
import { reactive } from '@nzyme/vue-utils/reactivity/reactive.js';
import { useDataSource } from '@nzyme/vue-utils/useDataSource.js';
import { computed, toValue } from 'vue';
import { formatProductPrice } from '@sigma/common/product/formatProductPrice.js';
import { useDateFormat } from '../i18n/useDateFormat.js';
import * as l from './useChatSubscriptionStart.loc.js';
/**
 * Shared load + formatting for the "subscription started" chat status card. The app-specific
 * subscription store is injected via `load`, so both app views become thin wrappers around this.
 */
export function useChatSubscriptionStart(options) {
    const t = useTranslate();
    const lang = useLanguage();
    const formatDate = useDateFormat();
    const info = useDataSource({
        params: () => toValue(options.subscriptionId),
        // useDataSource does not skip undefined params — guard so no request fires with undefined.
        load: subscriptionId => (subscriptionId ? options.load(subscriptionId) : Promise.resolve(undefined)),
        behavior: 'eager',
    });
    return reactive({
        loaded: computed(() => info.loaded),
        title: computed(() => info.value?.productName ?? ''),
        subtitle: computed(() => {
            const value = info.value;
            if (!value) {
                return null;
            }
            const price = formatProductPrice({
                price: value.price,
                currency: value.currency,
                type: value.productType,
                lang: lang.value,
            });
            const renews = t(l.renews, { date: formatDate(value.renewsAt, 'shortDate') });
            return `${price} · ${renews}`;
        }),
    });
}
//# sourceMappingURL=useChatSubscriptionStart.js.map